import { defineComponent, createBlock, openBlock, withCtx, createVNode, renderSlot, unref } from "vue";
import { SmartRenderer, resolveVNode } from "../../../lib/utils.js";
import _sfc_main$2 from "./Tooltip.js";
import _sfc_main$4 from "./TooltipContent.js";
import _sfc_main$1 from "./TooltipProvider.js";
import _sfc_main$3 from "./TooltipTrigger.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TooltipWrapper",
  props: {
    content: { type: [Object, String, Number, Boolean, null, Array, Function] },
    placement: {},
    reference: {}
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => (openBlock(), createBlock(_sfc_main$1, null, {
      default: withCtx(() => [
        createVNode(_sfc_main$2, null, {
          default: withCtx(() => [
            createVNode(_sfc_main$3, {
              "as-child": "",
              reference: props.reference
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            }, 8, ["reference"]),
            createVNode(_sfc_main$4, {
              side: props.placement
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "content", {}, () => [
                  createVNode(unref(SmartRenderer), {
                    children: unref(resolveVNode)(props.content)
                  }, null, 8, ["children"])
                ])
              ]),
              _: 3
            }, 8, ["side"])
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=TooltipWrapper.js.map
